import { Card } from '@ab-core/card';
import { cleanString, cleanStringRules } from '@ab-core/functions';
import { Col } from '@ab-core/grid';
import { InfoItem } from '@ab-core/infoitem';
import Markdown from '@ab-core/markdown';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React, { useEffect } from 'react';
import { MarkdownWrapper } from './changeLogCrds.styled';
import { isChangeLogUnread, setChangeLogRead } from './changeLogRead';
import { getChangeLog } from './getChangeLog';

type ChangeLogNode = Queries.ContentfulChangeLogGroupConnection['nodes'][number];

type ChangeLogCardProps = {
    changelog: ChangeLogNode;
};

export const isVisibleChangeLog = (changelog: ChangeLogNode): boolean => !changelog?.title?.includes('dummy');

const convertDate = (date: Date): string => date.toLocaleDateString();

export const ChangeLogCard: FC<ChangeLogCardProps> = ({ changelog }) => (
    <Card
        head={changelog?.title}
        active={isChangeLogUnread(changelog?.createdAt)}
        content={
            <>
                <InfoItem label="Datum" content={convertDate(new Date(changelog?.createdAt || new Date()))} />
                <MarkdownWrapper>
                    <Text>
                        <Markdown
                            markDown={cleanString(changelog?.description?.description || '', [
                                cleanStringRules.backslashNToBreak
                            ])}
                        />
                    </Text>
                </MarkdownWrapper>
            </>
        }
    />
);

export const ChangeLogCards: FC = () => {
    const allContentfulChangeLog = getChangeLog();

    useEffect(() => {
        setChangeLogRead();
    }, []);

    return (
        <>
            {allContentfulChangeLog?.nodes?.filter(isVisibleChangeLog).map((changelog) => (
                <Col md={10} key={changelog.id}>
                    <ChangeLogCard changelog={changelog} />
                </Col>
            ))}
        </>
    );
};
